'use client';

import classNames from 'classnames';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

import { themes } from 'app/components/common/MobileAppServices/themes';
import { IconLogoApp } from 'app/components/sprites';
import { useLayoutEffect, useState } from 'react';

import MobileAppServicesContent from 'app/components/common/MobileAppServices/Content';

export default function MobileAppServicesAnimation({
  googlePlay,
  appStore
}: {
  googlePlay?: string | null;
  appStore?: string | null;
}) {
  const [isComplete, setISComplete] = useState(false);

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(self => {
      const circles = document.querySelectorAll('.circle');
      const circlesCount = circles.length;
      if (!circlesCount) return;

      const specialistsSection = document.querySelector('.specialists');

      const timeline = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: '.trigger',
          start: 'top 10%'
        },
        onComplete: () => {
          setISComplete(true);
          specialistsSection?.classList?.add('show');
        }
      });

      circles.forEach((circle, index) => {
        timeline.to(circle, {
          duration: 0.05,
          opacity: 0,
          width: `${(circlesCount - 1 - index) * 10}%`
        });
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <div className="relative xl:pb-20 trigger">
      <div className="relative max-w-[1440px] mx-auto">
        <div
          className={classNames(
            'xl:opacity-0 xl:[&.show]:opacity-100 transition-opacity duration-600',
            { show: isComplete }
          )}
        >
          <MobileAppServicesContent
            theme={themes.light}
            googlePlay={googlePlay}
            appStore={appStore}
          />
        </div>

        <div className="abs-center w-full text-2xl md:text-4xl xl:text-7xl md:mt-[calc(((100%-48px)*0.5*0.32+2em+80px)/2)] xl:mt-[calc(((100%-48px)*0.3*0.32+2em+128px)/2)] pointer-events-none hidden xl:block">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-10 col-start-2">
              <div className="relative pb-[100%]">
                <div className="absolute inset-0 flex justify-center items-center">
                  <div className="rounded-md xl:rounded-2xl bg-graphite-dark w-10 xl:w-15 h-10 xl:h-15 flex flex-col justify-center items-center">
                    <IconLogoApp className="w-7 xl:w-10 h-7 xl:h-10 fill-sand-light pr-1" />

                    {[...Array(10)].map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="abs-center circle"
                          style={{ width: `${(10 - index) * 10}%` }}
                        >
                          <div className="pb-[100%] rounded-[43%] border border-graphite"></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
